import React, {FC, memo} from "react";

import Radio from "../Radio/Radio";
import {RadioTransformType} from "../Radio/Radio-types";
import {Item, Root} from "./SizesSelector-styles";
import {SizesSelectorProps} from "./SizesSelector-types";
import {RadioSkeleton} from "../Radio/Radio-skeleton";

const SizesSelector: FC<SizesSelectorProps> = memo((props) => {
    const {sizes, sizeActive, onChange, isLoading, isVisibleOnMobile, isDisabled} = props;

    return isLoading ? (
        <Root $isVisibleOnMobile={isVisibleOnMobile} $isDisabled={isDisabled}>
            <Item>
                <RadioSkeleton width={70} height={25}/>
            </Item>
            <Item>
                <RadioSkeleton width={95} height={25}/>
            </Item>
            <Item>
                <RadioSkeleton width={65} height={25}/>
            </Item>
        </Root>
    ) : (
        <Root $isVisibleOnMobile={isVisibleOnMobile} $isDisabled={isDisabled}>
            {
                sizes.map((size) => (
                    <Item key={size.id}>
                        <Radio
                            id={size.id}
                            value={size.id}
                            text={size.title}
                            checked={size.id === sizeActive?.id}
                            transformType={RadioTransformType.button}
                            onClick={onChange}/>
                    </Item>
                ))
            }
        </Root>
    );
});

export default SizesSelector;
